(function () {
  'use strict';

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: currency || 'CLP'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toLocaleString('es-CL');
    }
  }

  function moneyMajor(amount, currency) {
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: currency || 'CLP',
        maximumFractionDigits: (currency || 'CLP') === 'CLP' ? 0 : 2
      }).format(Number(amount || 0));
    } catch (error) {
      return '$' + Number(amount || 0).toLocaleString('es-CL');
    }
  }

  function track(name, data) {
    var detail = data || {};
    try {
      document.dispatchEvent(new CustomEvent('gamepulse:' + name, { detail: detail }));
    } catch (error) {}

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'gamepulse_' + name }, detail));
    }
  }

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize ? String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : String(value || '').toLowerCase();
  }

  function prioritySearchProducts() {
    var node = q('[data-gp-search-priority]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (error) { return []; }
  }

  function productMatchesQuery(product, query) {
    var haystack = normalizeSearchText((product && product.title) || '') + ' ' + normalizeSearchText((product && product.handle) || '');
    var needle = normalizeSearchText(query).trim();
    if (!needle) return false;
    var aliases = {
      'gta': ['gta', 'grand theft auto'],
      'grand theft': ['gta', 'grand theft auto'],
      'fc': ['fc 27', 'ea sports fc 27'],
      'fifa': ['fc 27', 'ea sports fc 27'],
      'black ops': ['black ops 6', 'call of duty black ops 6'],
      'elden': ['elden ring']
    };
    if (haystack.indexOf(needle) !== -1) return true;
    return Object.keys(aliases).some(function (key) {
      return needle.indexOf(key) !== -1 && aliases[key].some(function (alias) { return haystack.indexOf(alias) !== -1; });
    });
  }

  function mergePrioritySearch(products, query) {
    var merged = [];
    var seen = {};
    prioritySearchProducts().filter(function (product) { return productMatchesQuery(product, query); }).forEach(function (product) {
      var key = String(product.id || product.url || product.title || '');
      if (!seen[key]) { seen[key] = true; merged.push(product); }
    });
    (products || []).forEach(function (product) {
      var key = String(product.id || product.url || product.title || '');
      if (!seen[key]) { seen[key] = true; merged.push(product); }
    });
    return merged.slice(0, 6);
  }

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  function updateCartCount(count) {
    qa('[data-cart-count]').forEach(function (node) { node.textContent = String(count || 0); });
  }

  function updateComboAnnouncement(count) {
    var offer = q('.gp-announcement-offer');
    if (!offer) return;
    var drawer = q('[data-cart-drawer]');
    var discount2 = Number(drawer ? drawer.getAttribute('data-discount-2') : 10) || 10;
    var discount3 = Number(drawer ? drawer.getAttribute('data-discount-3') : 15) || 15;
    var link = offer.parentElement ? q('a', offer.parentElement) : null;
    var shopUrl = drawer ? drawer.getAttribute('data-shop-url') : rootPath() + 'collections/all';
    var cartUrl = drawer ? drawer.getAttribute('data-cart-url') : rootPath() + 'cart';
    if (count >= 3) {
      offer.innerHTML = '<strong>COMBO ACTIVO</strong><b>-' + discount3 + '%</b> máximo desbloqueado';
      if (link) { link.textContent = 'Ver carrito'; link.href = cartUrl; }
    } else if (count === 2) {
      offer.innerHTML = '<strong>YA AHORRAS</strong><b>-' + discount2 + '%</b> <i>·</i> suma 1 unidad y sube a <b>-' + discount3 + '%</b>';
      if (link) { link.textContent = 'Agregar 1 más'; link.href = shopUrl; }
    } else if (count === 1) {
      offer.innerHTML = '<strong>TE FALTA 1</strong> agrega otra unidad y desbloquea <b>-' + discount2 + '%</b>';
      if (link) { link.textContent = 'Elegir otro juego'; link.href = shopUrl; }
    } else {
      offer.innerHTML = '<strong>ARMA TU COMBO</strong><b>HASTA ' + discount3 + '% OFF</b> <i>·</i> 2 unidades -' + discount2 + '%';
    }
  }

  function closeCartDrawer() {
    var drawer = q('[data-cart-drawer]');
    var backdrop = q('[data-cart-drawer-backdrop]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('gp-cart-drawer-open');
    window.setTimeout(function () {
      drawer.hidden = true;
      if (backdrop) backdrop.hidden = true;
    }, 220);
  }

  function renderDrawerRecommendations(drawer, cart, currentProductId) {
    var wrap = q('[data-cart-drawer-recos]', drawer);
    var list = q('[data-cart-drawer-reco-list]', drawer);
    if (!wrap || !list) return;
    list.replaceChildren();
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (item) {
      inCart[String(item.product_id || '')] = true;
    });
    var picks = prioritySearchProducts().filter(function (product) {
      var id = String(product.id || '');
      return id && id !== String(currentProductId || '') && !inCart[id];
    }).slice(0, 2);
    if (!picks.length) { wrap.hidden = true; return; }
    picks.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'gp-cart-drawer-reco';
      link.href = product.url || '#';
      if (product.featured_image && product.featured_image.url) {
        var img = document.createElement('img');
        img.src = product.featured_image.url;
        img.alt = product.featured_image.alt || product.title || '';
        img.loading = 'lazy';
        link.appendChild(img);
      }
      var copy = document.createElement('span');
      var title = document.createElement('strong');
      title.textContent = product.title || 'Juego';
      var price = document.createElement('small');
      price.textContent = product.display_price || 'Ver opciones';
      copy.appendChild(title);
      copy.appendChild(price);
      link.appendChild(copy);
      link.addEventListener('click', function () {
        track('cart_drawer_recommendation_click', { product_id: product.id, title: product.title || '' });
      });
      list.appendChild(link);
    });
    wrap.hidden = false;
  }

  function openCartDrawer(info, cart) {
    var drawer = q('[data-cart-drawer]');
    var backdrop = q('[data-cart-drawer-backdrop]');
    if (!drawer) return false;

    var count = Number((cart && cart.item_count) || 0);
    var discount2 = Number(drawer.getAttribute('data-discount-2') || 10);
    var discount3 = Number(drawer.getAttribute('data-discount-3') || 15);
    var shopUrl = drawer.getAttribute('data-shop-url') || rootPath() + 'collections/all';
    var cartUrl = drawer.getAttribute('data-cart-url') || rootPath() + 'cart';
    var title = q('[data-cart-drawer-title]', drawer);
    var variant = q('[data-cart-drawer-variant]', drawer);
    var price = q('[data-cart-drawer-price]', drawer);
    var image = q('[data-cart-drawer-image]', drawer);
    var state = q('[data-cart-drawer-state]', drawer);
    var countNode = q('[data-cart-drawer-count]', drawer);
    var message = q('[data-cart-drawer-message]', drawer);
    var progress = q('[data-cart-drawer-progress]', drawer);
    var primary = q('[data-cart-drawer-primary]', drawer);
    var cartLink = q('[data-cart-drawer-cart]', drawer);

    if (title) title.textContent = info.title || 'Juego agregado';
    if (variant) variant.textContent = info.variantTitle || '';
    if (price) price.textContent = info.priceText || '';
    if (image) {
      if (info.image) { image.src = info.image; image.alt = info.title || ''; image.hidden = false; }
      else { image.removeAttribute('src'); image.hidden = true; }
    }
    if (countNode) countNode.textContent = count + (count === 1 ? ' unidad' : ' unidades');
    if (progress) progress.style.width = (count >= 3 ? 100 : count === 2 ? 66.666 : 33.333) + '%';
    if (cartLink) cartLink.href = cartUrl;

    if (count >= 3) {
      if (state) state.textContent = 'Máximo ahorro desbloqueado';
      if (message) message.innerHTML = '<strong>-' + discount3 + '% desbloqueado.</strong> Tu combo ya alcanzó el nivel máximo.';
      if (primary) { primary.textContent = 'Revisar carrito y pagar'; primary.href = cartUrl; }
      if (cartLink) { cartLink.textContent = 'Seguir comprando'; cartLink.href = shopUrl; }
      var recos = q('[data-cart-drawer-recos]', drawer);
      if (recos) recos.hidden = true;
    } else if (count === 2) {
      if (state) state.textContent = 'Ya ahorras -' + discount2 + '%';
      if (message) message.innerHTML = '<strong>Te falta solo 1 unidad.</strong> Agrega otra y sube al máximo: -' + discount3 + '%.';
      if (primary) { primary.textContent = 'Agregar 1 más · llegar al ' + discount3 + '%'; primary.href = shopUrl; }
      if (cartLink) { cartLink.textContent = 'Ver carrito'; cartLink.href = cartUrl; }
      renderDrawerRecommendations(drawer, cart, info.productId);
    } else {
      if (state) state.textContent = 'Tu combo ya empezó';
      if (message) message.innerHTML = '<strong>Te falta 1 unidad</strong> para desbloquear -' + discount2 + '% en tu compra.';
      if (primary) { primary.textContent = 'Elegir otro juego · desbloquear ' + discount2 + '%'; primary.href = shopUrl; }
      if (cartLink) { cartLink.textContent = 'Ver carrito'; cartLink.href = cartUrl; }
      renderDrawerRecommendations(drawer, cart, info.productId);
    }
    drawer.hidden = false;
    if (backdrop) backdrop.hidden = false;
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.documentElement.classList.add('gp-cart-drawer-open');
    });
    var close = q('[data-cart-drawer-close]', drawer);
    if (close) close.focus();
    track('cart_drawer_open', { items: count, product_id: info.productId || null });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-backdrop]')) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    var drawerPrimary = event.target.closest('[data-cart-drawer-primary]');
    var drawerCart = event.target.closest('[data-cart-drawer-cart]');
    if (drawerPrimary) track('cart_drawer_primary_click', { label: drawerPrimary.textContent.trim() });
    if (drawerCart) track('cart_drawer_cart_click');
  });

  function setMenu(open) {
    var nav = q('[data-mobile-nav]');
    var backdrop = q('[data-mobile-nav-backdrop]');
    var toggle = q('[data-menu-toggle]');
    if (!nav || !toggle) return;
    nav.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    document.documentElement.classList.toggle('gp-menu-open', !!open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
  }

  function setSearch(open) {
    var panel = q('[data-mobile-search]');
    var toggle = q('[data-search-toggle]');
    if (!panel || !toggle) return;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Cerrar búsqueda' : 'Buscar juegos');
    if (open) {
      setMenu(false);
      window.setTimeout(function () {
        var input = q('[data-predictive-input]', panel);
        if (input) input.focus();
      }, 20);
    }
  }

  function createPredictiveItem(product, currency) {
    var link = document.createElement('a');
    link.className = 'gp-predictive-item';
    link.href = product.url || '#';

    var media = document.createElement('span');
    media.className = 'gp-predictive-media';
    if (product.featured_image && product.featured_image.url) {
      var img = document.createElement('img');
      img.src = product.featured_image.url;
      img.alt = product.featured_image.alt || product.title || '';
      img.loading = 'lazy';
      media.appendChild(img);
    } else if (product.image) {
      var fallbackImg = document.createElement('img');
      fallbackImg.src = product.image;
      fallbackImg.alt = product.title || '';
      fallbackImg.loading = 'lazy';
      media.appendChild(fallbackImg);
    }

    var copy = document.createElement('span');
    copy.className = 'gp-predictive-copy';
    var title = document.createElement('strong');
    title.textContent = product.title || 'Juego';
    var meta = document.createElement('small');
    var price = Number(product.price_min || product.price || 0);
    meta.textContent = product.display_price || (price > 0 ? 'Desde ' + moneyMajor(price, currency) : 'Ver opciones');
    copy.appendChild(title);
    copy.appendChild(meta);

    var arrow = document.createElement('span');
    arrow.className = 'gp-predictive-arrow';
    arrow.textContent = '→';

    link.appendChild(media);
    link.appendChild(copy);
    link.appendChild(arrow);
    return link;
  }

  qa('[data-predictive-form]').forEach(function (form) {
    var input = q('[data-predictive-input]', form);
    var wrap = form.closest('.gp-predictive-wrap');
    var results = wrap ? q('[data-predictive-results]', wrap) : null;
    if (!input || !results) return;

    var timer = null;
    var controller = null;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';

    function hideResults() {
      results.hidden = true;
      results.replaceChildren();
    }

    function renderResults(products, query) {
      results.replaceChildren();
      if (!products.length) {
        var empty = document.createElement('div');
        empty.className = 'gp-predictive-empty';
        empty.textContent = 'No encontramos juegos para “' + query + '”.';
        results.appendChild(empty);
      } else {
        var heading = document.createElement('div');
        heading.className = 'gp-predictive-heading';
        heading.textContent = 'Juegos encontrados';
        results.appendChild(heading);
        products.forEach(function (product) {
          var item = createPredictiveItem(product, currency);
          item.addEventListener('click', function () {
            track('predictive_search_click', { query: query, product_id: product.id, title: product.title || '' });
          });
          results.appendChild(item);
        });
        var all = document.createElement('a');
        all.className = 'gp-predictive-all';
        all.href = rootPath() + 'search?q=' + encodeURIComponent(query) + '&type=product';
        all.textContent = 'Ver todos los resultados →';
        results.appendChild(all);
      }
      results.hidden = false;
    }

    function search() {
      var query = input.value.trim();
      if (query.length < 2) { hideResults(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = rootPath() + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) { if (!response.ok) throw new Error('search'); return response.json(); })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          products = mergePrioritySearch(products, query);
          renderResults(products, query);
          track('predictive_search', { query: query, results: products.length });
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          var fallbackProducts = mergePrioritySearch([], query);
          if (fallbackProducts.length) renderResults(fallbackProducts, query);
          else hideResults();
        });
    }

    input.addEventListener('input', function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(search, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && results.childNodes.length) results.hidden = false;
    });
    form.addEventListener('submit', function () {
      track('search_submit', { query: input.value.trim() });
    });
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) hideResults();
    });
  });

  document.addEventListener('click', function (event) {
    var modeJump = event.target.closest('a[href="#modalidades-mobile"]');
    if (modeJump) {
      var modeDetails = q('#modalidades-mobile');
      if (modeDetails) modeDetails.open = true;
    }
    var searchToggle = event.target.closest('[data-search-toggle]');
    var toggle = event.target.closest('[data-menu-toggle]');
    var closeMenu = event.target.closest('[data-menu-close]');
    var menuBackdrop = event.target.closest('[data-mobile-nav-backdrop]');
    if (closeMenu || menuBackdrop) {
      event.stopPropagation();
      setMenu(false);
    } else if (searchToggle) {
      event.stopPropagation();
      setSearch(searchToggle.getAttribute('aria-expanded') !== 'true');
    } else if (toggle) {
      event.stopPropagation();
      setSearch(false);
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    } else if (event.target.closest('[data-mobile-nav] a')) {
      setMenu(false);
    } else {
      var menuToggle = q('[data-menu-toggle]');
      if (
        menuToggle &&
        menuToggle.getAttribute('aria-expanded') === 'true' &&
        !event.target.closest('[data-mobile-nav]')
      ) {
        setMenu(false);
      }
    }

    var card = event.target.closest('[data-product-card]');
    if (card) {
      track('select_product', {
        product_id: card.getAttribute('data-product-id'),
        title: card.getAttribute('data-title') || ''
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { setMenu(false); setSearch(false); closeCartDrawer(); }
  });

  qa('[data-product-root]').forEach(function (root) {
    var variants = [];
    var media = [];

    try {
      variants = JSON.parse(q('[data-variants-json]', root).textContent);
    } catch (error) {}

    try {
      media = JSON.parse(q('[data-media-json]', root).textContent);
    } catch (error) {}

    var productId = Number(root.getAttribute('data-product-id') || 0);
    var productTitle = root.getAttribute('data-product-title') || '';
    var currency = root.getAttribute('data-currency') || 'CLP';
    var cartUrl = root.getAttribute('data-cart-url') || rootPath() + 'cart';
    var minPrice = Number(root.getAttribute('data-min-price') || 0);
    var hasInitialSelection = root.getAttribute('data-initial-selection') === 'true';

    var form = q('form[action*="/cart/add"]', root);
    var variantInput = form ? q('[data-variant-id]', form) : null;
    var groups = qa('[data-option-index]', root);
    var price = q('[data-product-price]', root);
    var priceLabel = q('[data-price-label]', root);
    var compare = q('[data-compare-price]', root);
    var sale = q('[data-sale-pill]', root);
    var selectionSummary = q('[data-selection-summary]', root);
    var selectionPrice = q('[data-selection-price]', root);
    var message = q('[data-form-message]', root);
    var addBtn = q('[data-add-cart]', root);
    var addLabel = q('[data-add-label]', root);
    var buyBtn = q('[data-buy-now]', root);
    var stickyAddBtn = q('[data-sticky-add]', root);
    var stickyBar = q('[data-product-sticky]', root);
    var mainPurchase = q('[data-main-purchase]', root);
    var stickyEligible = false;
    var mainPurchaseVisible = true;
    var stickyPrice = q('[data-sticky-price]', root);
    var stickySelection = q('[data-sticky-selection]', root);
    var availability = q('[data-availability-pill]', root);
    var modeCards = qa('[data-mode-card]', root);
    var modePriceNodes = qa('[data-mode-price]', root);
    var mainImage = q('.gp-gallery-main img', root);
    var thumbs = qa('[data-thumb]', root);
    var busy = false;

    function inputs(group) {
      return qa('[data-option-radio]', group);
    }

    function selected() {
      return groups.map(function (group) {
        var input = q('[data-option-radio]:checked', group);
        return input ? input.value : null;
      });
    }

    function isComplete(values) {
      return values.length === groups.length && values.every(function (value) { return value !== null; });
    }

    function exactVariant(values) {
      if (!isComplete(values)) return null;
      return variants.find(function (variant) {
        return values.every(function (value, index) {
          return variant.options[index] === value;
        });
      }) || null;
    }

    function compatibleVariant(values, requireAvailable) {
      return variants.find(function (variant) {
        if (requireAvailable && !variant.available) return false;
        return values.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      }) || null;
    }

    function current() {
      return exactVariant(selected());
    }

    function showMessage(text) {
      if (!message) return;
      message.textContent = text || '';
      message.classList.toggle('is-visible', Boolean(text));
    }

    function syncStickyVisibility() {
      if (!stickyBar) return;
      stickyBar.classList.toggle('is-visible', Boolean(stickyEligible && !mainPurchaseVisible));
    }

    function setActionsEnabled(enabled) {
      [addBtn, buyBtn, stickyAddBtn].forEach(function (button) {
        if (!button) return;
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
      });
    }

    function setBusy(next, checkoutIntent) {
      busy = next;
      if (form) form.setAttribute('aria-busy', String(next));
      if (next) {
        setActionsEnabled(false);
        if (addLabel) addLabel.textContent = checkoutIntent ? 'Preparando…' : 'Agregando…';
        if (buyBtn) buyBtn.textContent = checkoutIntent ? 'Preparando pago…' : 'Comprar ahora';
        if (stickyAddBtn) stickyAddBtn.textContent = 'Agregando…';
      } else {
        var variant = current();
        setActionsEnabled(Boolean(variant && variant.available && variant.price > 0));
        if (addLabel) addLabel.textContent = variant && variant.price <= 0 ? 'Precio por definir' : (variant && variant.available ? 'Agregar al carrito' : 'Agotado');
        if (buyBtn) buyBtn.textContent = 'Comprar ahora';
        if (stickyAddBtn) stickyAddBtn.textContent = 'Agregar';
      }
    }

    function syncOptionUi() {
      groups.forEach(function (group) {
        var active = q('[data-option-radio]:checked', group);
        var caption = q('[data-option-caption]', group);
        if (caption) caption.textContent = active ? active.value : 'Selecciona';

        inputs(group).forEach(function (input) {
          var label = input.closest('[data-option-label]');
          if (label) label.classList.toggle('is-active', input.checked);
        });
      });
    }

    function syncModeCards() {
      if (!modeCards.length) return;
      var values = selected();
      var activeMode = values.find(function (value) {
        return value === 'Primaria' || value === 'Secundaria';
      }) || '';
      modeCards.forEach(function (card) {
        var isActive = card.getAttribute('data-mode-card') === activeMode;
        card.classList.toggle('is-selected', isActive);
      });
    }

    function syncModePrices() {
      if (!modePriceNodes.length) return;
      var values = selected();
      var modeIndex = -1;
      groups.some(function (group, index) {
        var groupValues = inputs(group).map(function (input) { return input.value; });
        if (groupValues.indexOf('Primaria') !== -1 || groupValues.indexOf('Secundaria') !== -1) {
          modeIndex = index;
          return true;
        }
        return false;
      });
      if (modeIndex < 0) return;

      modePriceNodes.forEach(function (node) {
        var mode = node.getAttribute('data-mode-price');
        var matches = variants.filter(function (variant) {
          if (!variant.available || Number(variant.price) <= 0) return false;
          if (variant.options[modeIndex] !== mode) return false;
          return values.every(function (value, index) {
            if (index === modeIndex || value === null) return true;
            return variant.options[index] === value;
          });
        });
        if (!matches.length) {
          node.textContent = 'No disponible';
          return;
        }
        var prices = matches.map(function (variant) { return Number(variant.price); });
        var min = Math.min.apply(Math, prices);
        var max = Math.max.apply(Math, prices);
        node.textContent = (min === max ? '' : 'Desde ') + money(min, currency);
      });
    }

    function refreshValidity() {
      var values = selected();
      groups.forEach(function (group, index) {
        inputs(group).forEach(function (input) {
          var candidate = values.slice();
          candidate[index] = input.value;
          var exists = Boolean(compatibleVariant(candidate, false));
          input.disabled = !exists;
          var label = input.closest('[data-option-label]');
          if (label) label.classList.toggle('is-disabled', !exists);
        });
      });
    }

    function setImage(imageId) {
      if (!mainImage || !imageId) return;
      var item = media.find(function (entry) {
        return Number(entry.id) === Number(imageId);
      });
      if (!item) return;

      mainImage.src = item.src;
      if (item.srcset) mainImage.srcset = item.srcset;
      thumbs.forEach(function (thumb) {
        var active = Number(thumb.getAttribute('data-image-id')) === Number(imageId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }

    function renderIncompleteState() {
      if (priceLabel) priceLabel.textContent = 'Desde';
      if (price) price.textContent = money(minPrice, currency);
      if (compare) {
        compare.textContent = '';
        compare.hidden = true;
      }
      if (sale) sale.hidden = true;
      if (selectionSummary) selectionSummary.textContent = 'Completa tu selección';
      if (selectionPrice) selectionPrice.textContent = '—';
      if (stickySelection) stickySelection.textContent = 'Elige plataforma y modalidad';
      if (stickyPrice) stickyPrice.textContent = 'Desde ' + money(minPrice, currency);
      stickyEligible = false;
      syncStickyVisibility();
      setActionsEnabled(false);
      syncOptionUi();
      syncModeCards();
      syncModePrices();
      refreshValidity();
      showMessage('');
    }

    function renderVariant(variant, shouldTrack) {
      var hasPrice = Number(variant.price) > 0;
      var formatted = hasPrice ? money(variant.price, currency) : 'Precio por definir';
      var label = (variant.options || []).join(' · ');

      if (variantInput) variantInput.value = variant.id;
      if (priceLabel) priceLabel.textContent = hasPrice ? 'Precio seleccionado' : 'Precio';
      if (price) price.textContent = formatted;
      if (selectionPrice) selectionPrice.textContent = hasPrice ? formatted : '—';
      if (selectionSummary) selectionSummary.textContent = label;
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (stickySelection) stickySelection.textContent = label;

      syncOptionUi();
      syncModeCards();
      syncModePrices();
      refreshValidity();

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) {
        compare.textContent = hasCompare ? money(variant.compare_at_price, currency) : '';
        compare.hidden = !hasCompare;
      }
      if (sale) sale.hidden = !hasCompare;

      stickyEligible = Boolean(variant.available && hasPrice);
      syncStickyVisibility();
      setActionsEnabled(Boolean(variant.available && hasPrice));
      if (addLabel) addLabel.textContent = !hasPrice ? 'Precio por definir' : (variant.available ? 'Agregar al carrito' : 'Agotado');

      if (availability) {
        availability.textContent = variant.available ? '' : 'Agotado';
        availability.hidden = !!variant.available;
        availability.classList.toggle('is-off', !variant.available);
      }

      if (variant.featured_image && variant.featured_image.id) {
        setImage(variant.featured_image.id);
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {}

      showMessage('');

      if (shouldTrack) {
        track('select_variant', {
          product_id: productId,
          product_title: productTitle,
          variant_id: variant.id,
          selection: label,
          price: variant.price
        });
      }
    }

    function update(shouldTrack) {
      var values = selected();
      syncOptionUi();
      refreshValidity();

      if (!isComplete(values)) {
        renderIncompleteState();
        return;
      }

      var variant = exactVariant(values);
      if (!variant) {
        renderIncompleteState();
        showMessage('Esa combinación no está disponible. Elige otra opción.');
        return;
      }

      renderVariant(variant, shouldTrack);
    }

  
    if (mainPurchase && stickyBar && 'IntersectionObserver' in window) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mainPurchaseVisible = entry.isIntersecting;
          syncStickyVisibility();
        });
      }, { threshold: 0.12 });
      purchaseObserver.observe(mainPurchase);
    } else if (mainPurchase && stickyBar) {
      function checkMainPurchaseVisibility() {
        var rect = mainPurchase.getBoundingClientRect();
        mainPurchaseVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        syncStickyVisibility();
      }
      window.addEventListener('scroll', checkMainPurchaseVisibility, { passive: true });
      window.addEventListener('resize', checkMainPurchaseVisibility);
      checkMainPurchaseVisibility();
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function (event) {
        if (!event.target.matches('[data-option-radio]')) return;
        track('select_option', {
          product_id: productId,
          product_title: productTitle,
          option: group.getAttribute('data-option-name') || '',
          value: event.target.value
        });
        update(true);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setImage(thumb.getAttribute('data-image-id'));
      });
    });

    async function add(goToCheckout) {
      if (busy) return;
      var values = selected();
      if (!isComplete(values)) {
        showMessage('Elige plataforma y modalidad antes de continuar.');
        var firstIncomplete = groups.find(function (group) {
          return !q('[data-option-radio]:checked', group);
        });
        if (firstIncomplete) firstIncomplete.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var variant = exactVariant(values);
      if (!variant) {
        showMessage('Selecciona una combinación válida.');
        return;
      }
      if (!variant.available) {
        showMessage('Esta variante no está disponible.');
        return;
      }
      if (Number(variant.price) <= 0) {
        showMessage('Este juego aún no tiene precio disponible.');
        return;
      }

      showMessage('');
      setBusy(true, goToCheckout);

      try {
        var response = await fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        var data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
        }

        track('add_to_cart', {
          product_id: productId,
          product_title: productTitle,
          variant_id: variant.id,
          price: variant.price,
          checkout: goToCheckout
        });

        if (goToCheckout) {
          track('begin_checkout', { source: 'buy_now', product_id: productId });
          var checkoutForm = document.createElement('form');
          checkoutForm.method = 'post';
          checkoutForm.action = cartUrl;
          var checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = 'checkout';
          checkoutForm.appendChild(checkoutInput);
          document.body.appendChild(checkoutForm);
          checkoutForm.submit();
          return;
        }

        var cartResponse = await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
        var cart = cartResponse.ok ? await cartResponse.json() : null;
        if (!cart) {
          var currentCountNode = q('[data-cart-count]');
          var previousCount = Number(currentCountNode ? currentCountNode.textContent : 0) || 0;
          cart = { item_count: previousCount + 1, items: [] };
        }
        updateCartCount(cart.item_count);
        updateComboAnnouncement(cart.item_count);
        setBusy(false, false);
        if (addLabel) {
          addLabel.textContent = '✓ Agregado';
          window.setTimeout(function () {
            var activeVariant = current();
            if (addLabel) addLabel.textContent = activeVariant && activeVariant.available && activeVariant.price > 0 ? 'Agregar al carrito' : 'Agotado';
          }, 1300);
        }
        var drawerOpened = openCartDrawer({
          productId: productId,
          title: productTitle,
          variantTitle: variant.title || values.join(' · '),
          priceText: money(Number(variant.price), currency),
          image: mainImage ? (mainImage.currentSrc || mainImage.src || '') : ''
        }, cart || { item_count: 0, items: [] });
        if (!drawerOpened) showMessage('✓ Agregado al carrito.');
      } catch (error) {
        setBusy(false, false);
        showMessage(error.message || 'No pudimos agregar el producto. Intenta nuevamente.');
      }
    }

    // The primary add-to-cart action is an explicit button, not a native form submit.
    // This guarantees the AJAX drawer flow on desktop as well as mobile and prevents
    // Shopify's native /cart/add form redirect from taking over if a submit handler is missed.
    if (addBtn) addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      add(false);
    });
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        add(false);
      });
    }
    if (buyBtn) buyBtn.addEventListener('click', function () { add(true); });
    if (stickyAddBtn) stickyAddBtn.addEventListener('click', function () { add(false); });

    groups.forEach(function (group) {
      var radios = inputs(group);
      if (radios.length === 1 && !q('[data-option-radio]:checked', group)) radios[0].checked = true;
    });

    if (hasInitialSelection) {
      var initialVariant = current();
      if (initialVariant) renderVariant(initialVariant, false);
      else renderIncompleteState();
    } else {
      renderIncompleteState();
    }

    track('view_product', {
      product_id: productId,
      product_title: productTitle,
      variant_id: hasInitialSelection && current() ? current().id : null
    });
  });

  qa('[data-product-recommendations]').forEach(function (node) {
    var url = node.getAttribute('data-url');
    if (!url || q('.gp-recommendation-grid', node)) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = q('[data-product-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) node.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  (function () {
    var cart = q('[data-gp-cart]');
    if (!cart) return;

    var checkout = q('[data-begin-checkout]', cart);
    if (checkout) {
      checkout.addEventListener('click', function () {
        track('begin_checkout', {
          source: 'cart',
          items: Number((q('[data-cart-count]', cart) || {}).textContent || 0)
        });
      });
    }

    var cartForm = q('form', cart);
    var updateButton = q('[name="update"]', cart);
    var quantityTimer = null;
    qa('input[name="updates[]"]', cart).forEach(function (input) {
      input.addEventListener('change', function () {
        var value = Math.max(0, parseInt(input.value || '0', 10));
        input.value = String(value);
        track('change_quantity', { quantity: value });
        if (!cartForm || !updateButton) return;
        if (quantityTimer) window.clearTimeout(quantityTimer);
        updateButton.textContent = 'Actualizando…';
        updateButton.disabled = true;
        quantityTimer = window.setTimeout(function () {
          updateButton.disabled = false;
          cartForm.requestSubmit(updateButton);
        }, 450);
      });
    });
  })();

  (function () {
    var promo = q('[data-combo-popup]');
    if (!promo) return;

    var key = promo.getAttribute('data-storage-key') || 'gp_combo_seen_v7';
    try {
      if (sessionStorage.getItem(key) === '1') return;
    } catch (error) {}

    var shown = false;
    var closed = false;
    var timer = null;
    var delay = Math.max(6000, parseInt(promo.getAttribute('data-delay') || '12000', 10));

    function remember() {
      try { sessionStorage.setItem(key, '1'); } catch (error) {}
    }

    function show() {
      if (shown || closed) return;
      shown = true;
      promo.hidden = false;
      requestAnimationFrame(function () { promo.classList.add('is-visible'); });
      remember();
      track('combo_view', { placement: 'popup' });
    }

    function close() {
      if (closed) return;
      closed = true;
      promo.classList.remove('is-visible');
      remember();
      window.setTimeout(function () { promo.hidden = true; }, 260);
    }

    function maybeOnScroll() {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      if (window.scrollY / max >= 0.32) {
        window.removeEventListener('scroll', maybeOnScroll);
        if (timer) window.clearTimeout(timer);
        window.setTimeout(show, 500);
      }
    }

    timer = window.setTimeout(show, delay);
    window.addEventListener('scroll', maybeOnScroll, { passive: true });

    var closeBtn = q('[data-combo-close]', promo);
    var cta = q('[data-combo-cta]', promo);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (cta) {
      cta.addEventListener('click', function () {
        remember();
        track('combo_click', { placement: 'popup' });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && shown && !closed) close();
    });
  })();


  // Progressive disclosure for long product descriptions on phones.
  qa('[data-description-wrap]').forEach(function (wrap) {
    var description = q('[data-product-description]', wrap);
    var toggle = q('[data-description-toggle]', wrap);
    if (!description || !toggle) return;

    function configureDescription() {
      var mobile = window.matchMedia('(max-width: 820px)').matches;
      if (!mobile) {
        description.classList.remove('is-collapsed');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      if (toggle.getAttribute('aria-expanded') !== 'true') {
        description.classList.add('is-collapsed');
      }
      requestAnimationFrame(function () {
        var needsToggle = description.scrollHeight > description.clientHeight + 6 || toggle.getAttribute('aria-expanded') === 'true';
        toggle.hidden = !needsToggle;
        if (!needsToggle) description.classList.remove('is-collapsed');
      });
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      description.classList.toggle('is-collapsed', expanded);
      toggle.firstChild.nodeValue = expanded ? 'Leer descripción completa ' : 'Mostrar menos ';
    });

    configureDescription();
    window.addEventListener('resize', configureDescription);
  });

})();
